import React from "react";
import style from "./index.module.scss";
import Activity from "../../../../CourseDetail/Report/components/Activity";
import Resource from "../../../../CourseDetail/Report/components/Resource";
import { ProjectionScreenReport } from "../../../../../service/report";
import LiveEvents from "./Components/LiveEvents";

interface TeachAnalyseProps {
    data: ProjectionScreenReport;
}

export default function TeachAnalyse({ data }: TeachAnalyseProps) {
    return (
        <div className={style.root}>
            {data && (
                <>
                    <Resource resourceData={data} />
                    <Activity activityData={data} />
                    <LiveEvents eventsData={data} />
                </>
            )}
        </div>
    );
}
